import React, { useState } from "react";
import { Box, Grid, TextField, Typography } from "@mui/material";
import GeneralModal from "../../GeneralModal/GeneralModal";
import ContactEmergencyIcon from "@mui/icons-material/ContactEmergency";
import { useDispatch, useSelector } from "react-redux";
import { setDialog, User } from "../../../app/slices/Users/userSlice";
import { showNotification } from "../../../app/slices/notificationSlice";
export default function ModalInfo() {
  const dispatch = useDispatch();
  const {
    manageUser: { dialog, form, loading },
  } = useSelector((state) => state.user);
  
  const [passwordError, setPasswordError] = useState("");
  
  // send request
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const password = data.get("password");
    const passwordConfirmation = data.get("password_confirmation");
    
    // Reset password error
    setPasswordError("");
    
    // Validate password confirmation for new users
    if (!form.id && password !== passwordConfirmation) {
      setPasswordError("Passwords do not match");
      dispatch(
        showNotification({
          type: "error",
          message: "Passwords do not match",
        })
      );
      return;
    }
    
    const infoData = {
      name: data.get("name"),
      email: data.get("email"),
      password: password,
      mobile: data.get("mobile"),
    };

    // function api request
    if (form.id) {
      dispatch(User.update(form.id, infoData));
    } else {
      dispatch(User.create(infoData));
    }
  };
  // close modal
  const handleClose = () => {
    setPasswordError("");
    dispatch(setDialog());
  };
  return (
    <GeneralModal
      maxWidth="md"
      open={dialog}
      onSubmit={handleSubmit}
      handleClose={handleClose}
      loading={loading}
      type={form?.id ? "edit" : "add"}
    >
      <Box sx={{ mx: 2, my: 2 }}>
        <Box sx={{ mx: 2, mt: 1, display: "flex", alignItems: "center" }}>
          <ContactEmergencyIcon color={"primary"} />
          <Typography variant="h5" fontSize={18} fontWeight={500}>
            &nbsp; {form?.id ? "Edit Admin" : "Add Admin"}
          </Typography>
        </Box>

        <Grid container>
          <Grid item xs={12} sm={6}>
            <Box
              sx={{
                mx: 2,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <TextField
                size="small"
                margin="normal"
                fullWidth
                name="name"
                required
                label="Name"
                type="text"
                id="name"
                defaultValue={form?.name}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box
              sx={{
                mx: 2,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <TextField
                size="small"
                margin="normal"
                fullWidth
                required
                name="email"
                label="Email"
                type="text"
                id="email"
                defaultValue={form?.email}
              />
            </Box>
          </Grid>
          {!form.id && (
            <>
              <Grid item xs={12} sm={6}>
                <Box
                  sx={{
                    mx: 2,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <TextField
                    size="small"
                    margin="normal"
                    fullWidth
                    required
                    name="password"
                    label="Password"
                    type="password"
                    id="password"
                    error={!!passwordError}
                    helperText={passwordError}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box
                  sx={{
                    mx: 2,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <TextField
                    size="small"
                    margin="normal"
                    fullWidth
                    required
                    name="password_confirmation"
                    label="Confirm Password"
                    type="password"
                    id="password_confirmation"
                    error={!!passwordError}
                    helperText={passwordError && ""}
                  />
                </Box>
              </Grid>
            </>
          )}
          <Grid item xs={12}>
            <Box
              sx={{
                mx: 2,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <TextField
                key={form?.mobile}
                size="small"
                margin="normal"
                fullWidth
                required
                name="mobile"
                label="Mobile"
                type="phone"
                id="mobile"
                defaultValue={form?.mobile}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </GeneralModal>
  );
}
